'use client';

import type {MobileSubMenuListProps as Props} from './typings';

import {StyledSideMenuList, StyledSideMenuListItem} from './styles';

const MobileSubMenuList = ({submenu, handleItemClick, marginTop, isActive}: Props): JSX.Element => {
  const {title, links, highlights} = submenu;

  return (
    <StyledSideMenuList title={title} $marginTop={marginTop}>
      {links.map(({link, text, component}) => {
        return (
          <StyledSideMenuListItem key={`${text}${link}`} $isSubMenu>
            <a href={link as string} onClick={handleItemClick} tabIndex={isActive ? 0 : -1}>
              {text || component}
            </a>
          </StyledSideMenuListItem>
        );
      })}

      {highlights?.length &&
        highlights.map(({text, component, link}) => {
          return (
            <StyledSideMenuListItem key={`highlight-${text}${link}`} $isSubMenu>
              <a href={link as string} onClick={handleItemClick} tabIndex={isActive ? 0 : -1}>
                {text || component}
              </a>
            </StyledSideMenuListItem>
          );
        })}
    </StyledSideMenuList>
  );
};

export default MobileSubMenuList;
